import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { getAPI, putAPI, delAPI } from '../utils/APIUtils';

import { appActions } from '../actions/appAction';

export interface EditingAct {
    stepId: any;
    editingId: string;
    actId: string;
    title: string;
    newTitle: string;
    editType: string;
    actNum: string;
    editActNum: string;
    editState: string;
};

export interface EditStateAPIParam {
    editingId: string;
    actId: string;
    editState: string;
    editType?: string;
    accountId: string;
    idid: string;
    id: string;
};

const actionCreator = actionCreatorFactory();

export const editingActsAction = {
    getEditingActTables: actionCreator<EditingAct[]>('ACTIONS_GET_EDITING_ACT_TABLES'),
    getEditingActTablesAsync: (accountId: string,) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                // &state=editing 付与で編集終了前の一覧を取得
                const url = `/editingacts?accountid=${accountId}&state=editing`;
                const json = await getAPI(url);

                const tables = json.map(item => {
                    const result: EditingAct = {
                        editingId: item.editingId,
                        actId: item.actId,
                        title: item.title,
                        newTitle: item.newTitle,
                        editType: item.editType,
                        actNum: item.actNum,
                        editActNum: item.editActNum,
                        editState: item.editState,
                        stepId: item.stepId,
                    };
                    return result;
                });
                dispatch(editingActsAction.getEditingActTables(tables));
            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        };
    },
    deleteEditingActAsync: (accountId: string, idid: string, actId: string, editingId: string) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                const url = `/acts/${actId}/editings/${editingId}?accountid=${accountId}&idid=${idid}`;
                await delAPI(url);

                // 再取得
                await editingActsAction.getEditingActTablesAsync(accountId)(dispatch);
            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        }
    },
    putEditStateAsync: (param: EditStateAPIParam) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                // 編集状態更新
                const url = `/acts/${param.actId}/editings/${param.editingId}/editstate`;
                const options = {
                    accountid: param.accountId,
                    id: param.id,
                    editState: param.editState,
                };
                await putAPI(url, options);

                // 再取得
                await editingActsAction.getEditingActTablesAsync(param.accountId)(dispatch);
            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        }
    }
}